// extracted by mini-css-extract-plugin
export default {"main":"PageLayout_main__lZ20m"};